import React from 'react';
import {Stack as MuiStack} from '@mui/material';
import {styled} from '@mui/material/styles';
import {StackProps} from './StackProps';
import {media} from '@/styles/mediaQueries';

const StyledStack = styled(MuiStack)({
  '&.MuiStack-root': {
    [media.mobile]: {
      width: '100%',
    },
  },
});

function Stack(props: StackProps) {
  const {children, ...rest} = props;
  return <StyledStack {...rest}>{children}</StyledStack>;
}

export default Stack;
